import { auth } from 'firebase/app'
import cookie from '@/plugins/cookie'

function decodeJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(atob(base64))
}

const userHasAccess = (userRoles, routeRoles) => routeRoles.some(role => userRoles.includes(role))

const requireAuth = async (to, from, next)  => {
	const { currentUser } = auth()
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

	if (!requiresAuth) {
		next()
		return
	}

	if (requiresAuth && !currentUser) {
		console.log('hola');
		console.log(window.location.pathname)
		if(window.location.pathname.includes('softphone-widget')){
			next('/auth/login?mode=widget')
			return
		}
		next('/auth/login')
		return
	}

	const token = cookie.getCookie()

	if (token == '' && currentUser) {
		auth().signOut().then(() => {
		if(window.location.pathname.includes('softphone-widget')){
			next('/auth/login?mode=widget')
			return
		}
			next('/auth/login')
		})
	}


	const { roles } = decodeJwt(token)
	const isAdmin = roles.includes('ROLE_ADMIN')
	let hasAccess = isAdmin

	if (to.meta.access_control && !isAdmin) {
		hasAccess = userHasAccess(roles, to.meta.access_control)
	}

	if (hasAccess) {
		next()
	} else {
		next('home')
	}
}

export default requireAuth

